/* Proaid Nutrition — global theme JS (no framework dependencies).
   Handles: money formatting, Ajax cart (add/change) + cart drawer,
   header mobile drawer + health-goals dropdown, announcement rotation,
   welcome popup. */
(function () {
  'use strict';

  /* ── Money formatting ─────────────────────────────────────── */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || (window.theme && window.theme.moneyFormat) || '£{{ amount }}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }
  window.theme = window.theme || {};
  window.theme.formatMoney = formatMoney;

  /* ── Cart API ─────────────────────────────────────────────── */
  var cartRequestConfig = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
  };

  function refreshCartDrawer(openDrawer) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('#CartDrawer');
        var current = document.querySelector('#CartDrawer');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
        }
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r ? r.json() : null; })
      .then(function (cart) {
        if (cart) updateCartCount(cart.item_count);
        if (openDrawer) window.theme.openCartDrawer();
      });
  }
  window.theme.refreshCartDrawer = refreshCartDrawer;

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    document.querySelectorAll('[data-cart-icon-button]').forEach(function (el) {
      el.setAttribute('aria-label', el.getAttribute('data-label-template').replace('[count]', count));
    });
  }

  window.theme.addToCart = function (items) {
    var payload = Array.isArray(items) ? { items: items } : { items: [items] };
    return fetch(window.theme.routes.cartAdd + '.js', Object.assign({}, cartRequestConfig, { body: JSON.stringify(payload) }))
      .then(function (r) {
        if (!r.ok) return r.json().then(function (data) { throw new Error(data.description || window.theme.strings.cartError); });
        return r.json();
      })
      .then(function () { return refreshCartDrawer(true); });
  };

  window.theme.changeCartLine = function (line, quantity) {
    return fetch(window.theme.routes.cartChange + '.js', Object.assign({}, cartRequestConfig, {
      body: JSON.stringify({ line: line, quantity: quantity })
    }))
      .then(function (r) {
        if (!r.ok) throw new Error(window.theme.strings.cartError);
        return r.json();
      })
      .then(function () { return refreshCartDrawer(false); });
  };

  /* ── Cart drawer open/close ───────────────────────────────── */
  window.theme.openCartDrawer = function () {
    var drawer = document.querySelector('#CartDrawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    var overlay = document.querySelector('[data-cart-overlay]');
    if (overlay) overlay.classList.add('is-active');
    document.body.classList.add('drawer-open');
  };
  window.theme.closeCartDrawer = function () {
    var drawer = document.querySelector('#CartDrawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    var overlay = document.querySelector('[data-cart-overlay]');
    if (overlay) overlay.classList.remove('is-active');
    document.body.classList.remove('drawer-open');
  };

  /* ── Delegated events ─────────────────────────────────────── */
  document.addEventListener('click', function (event) {
    var target;

    /* Open cart drawer */
    target = event.target.closest('[data-cart-open]');
    if (target) { event.preventDefault(); window.theme.openCartDrawer(); return; }

    /* Close cart drawer */
    target = event.target.closest('[data-cart-close], [data-cart-overlay]');
    if (target) { event.preventDefault(); window.theme.closeCartDrawer(); return; }

    /* Quick add-to-cart buttons (product cards, upsells) */
    target = event.target.closest('[data-add-to-cart]');
    if (target) {
      event.preventDefault();
      var variantId = Number(target.getAttribute('data-add-to-cart'));
      var qty = Number(target.getAttribute('data-quantity') || 1);
      if (!variantId) return;
      target.setAttribute('aria-busy', 'true');
      target.disabled = true;
      window.theme.addToCart({ id: variantId, quantity: qty })
        .catch(function (error) { showCartError(error.message); })
        .finally(function () {
          target.removeAttribute('aria-busy');
          target.disabled = false;
        });
      return;
    }

    /* Cart line quantity +/- and remove */
    target = event.target.closest('[data-cart-change]');
    if (target) {
      event.preventDefault();
      var line = Number(target.getAttribute('data-line'));
      var quantity = Number(target.getAttribute('data-cart-change'));
      var region = document.querySelector('[data-cart-lines]');
      if (region) region.setAttribute('aria-busy', 'true');
      window.theme.changeCartLine(line, quantity)
        .catch(function (error) { showCartError(error.message); })
        .finally(function () {
          var r = document.querySelector('[data-cart-lines]');
          if (r) r.removeAttribute('aria-busy');
        });
      return;
    }

    /* Mobile menu */
    target = event.target.closest('[data-menu-open]');
    if (target) { toggleMobileMenu(true); return; }
    target = event.target.closest('[data-menu-close], [data-menu-overlay]');
    if (target) { toggleMobileMenu(false); return; }
  });

  function showCartError(message) {
    var el = document.querySelector('[data-cart-error]');
    if (!el) { window.alert(message); return; }
    el.textContent = message || window.theme.strings.cartError;
    el.hidden = false;
    window.clearTimeout(el._timer);
    el._timer = window.setTimeout(function () { el.hidden = true; }, 4000);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      window.theme.closeCartDrawer();
      toggleMobileMenu(false);
    }
  });

  /* ── Header: mobile drawer ────────────────────────────────── */
  function toggleMobileMenu(open) {
    var drawer = document.querySelector('[data-mobile-menu]');
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }

  /* ── Header: mega dropdown (hover, desktop only) ──────────── */
  var header = document.querySelector('[data-header]');
  if (header) {
    header.querySelectorAll('[data-megamenu-trigger]').forEach(function (trigger) {
      trigger.addEventListener('mouseenter', function () { header.classList.add('megamenu-open'); });
    });
    header.querySelectorAll('.site-header__nav-link:not([data-megamenu-trigger] *)').forEach(function (link) {
      if (!link.closest('[data-megamenu-trigger]')) {
        link.addEventListener('mouseenter', function () { header.classList.remove('megamenu-open'); });
      }
    });
    header.addEventListener('mouseleave', function () { header.classList.remove('megamenu-open'); });
  }

  /* ── Announcement bar rotation (3s, fade + slide transition) ── */
  document.querySelectorAll('[data-announcement-rotate]').forEach(function (bar) {
    var messages = bar.querySelectorAll('[data-announcement-message]');
    if (messages.length < 2) return;
    var index = 0;
    messages[index].classList.add('is-active');
    window.setInterval(function () {
      messages[index].classList.remove('is-active');
      index = (index + 1) % messages.length;
      messages[index].classList.add('is-active');
    }, 3000);
  });

  /* ── Welcome popup (4.5s delay, localStorage, 7-day snooze) ── */
  var popup = document.querySelector('[data-welcome-popup]');
  if (popup) {
    var KEY = 'proaid_welcome_v1';
    var justPosted = popup.querySelector('[data-popup-posted]') !== null;
    var show = true;
    try {
      var stored = window.localStorage.getItem(KEY);
      if (stored) {
        var data = JSON.parse(stored);
        if (data.submitted) show = false;
        else if (data.dismissedAt && Date.now() - data.dismissedAt < 7 * 24 * 3600 * 1000) show = false;
      }
    } catch (e) { /* storage unavailable */ }

    var dismissPopup = function () {
      try { window.localStorage.setItem(KEY, JSON.stringify({ dismissedAt: Date.now() })); } catch (e) { /* noop */ }
      popup.hidden = true;
    };

    if (justPosted) {
      /* Newsletter form posted — show the success ("You're in") state now */
      try { window.localStorage.setItem(KEY, JSON.stringify({ submitted: true })); } catch (e) { /* noop */ }
      popup.hidden = false;
    } else if (show) {
      window.setTimeout(function () { popup.hidden = false; }, 4500);
    }

    popup.addEventListener('click', function (event) {
      if (event.target === popup || event.target.closest('[data-popup-close]')) dismissPopup();
    });

    var form = popup.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        try {
          var email = form.querySelector('input[type="email"]');
          window.localStorage.setItem(KEY, JSON.stringify({ submitted: true, email: email ? email.value : '' }));
        } catch (e) { /* noop */ }
      });
    }
  }
})();
